import { render } from "./FixedMobile.vue?vue&type=template&id=d3c09b62"
import script from "./FixedMobile.vue?vue&type=script&lang=js"
export * from "./FixedMobile.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sr.vlas/vendor/v-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__